import { useState, useEffect } from 'react'
import {nanoid} from "nanoid"
import Home from "./components/Home"
import Editor from "./components/Editor"
import Footer from "./components/Footer"
import './App.css';

export default function App() {
  const [darkMode, toggleMode] = useState(localStorage.getItem('dark') || false)
  const [home, toggleHome] = useState(true)
  const [count, setCount] = useState(() => JSON.parse(localStorage.getItem('journals')) ? JSON.parse(localStorage.getItem('journals')).length : 0)
  const [journal, setjournal] = useState(() => JSON.parse(localStorage.getItem('journals')) || [])
  const [currentJournalId, setCurrentJournalId] = useState(
      (journal[0] && journal[0].id) || ""
  )

  function toggleDark() {
    toggleMode(prevMode => !prevMode)
    console.log(darkMode)
  }

  useEffect(() => {
    localStorage.setItem('journals', JSON.stringify(journal))
  }, [journal])

  function deleteJournal(event, journalId) {
    event.stopPropagation()
    setjournal(oldJournals => oldJournals.filter(journal => journal.id !== journalId))
  }
  
  function createNewJournal() {
      const newJournal = {
          id: JSON.parse(localStorage.getItem('journals')) ? JSON.parse(localStorage.getItem('journals')).length + 1 : count + 1,
          key: nanoid(),
          title: "Untitled",
          body: ""
      }
      setjournal(prevjournal => [newJournal, ...prevjournal])
      setCurrentJournalId(newJournal.id)
      setCount(prevCount => prevCount + 1)
      toggle()
  }
  
  function updateJournalBody(text) {
      setjournal(oldJournal => {
        const newArray = []
        for(let i=0; i<oldJournal.length; i++) {
            if(oldJournal[i].id === currentJournalId) {
                newArray.unshift({ ...oldJournal[i], body: text })
            } else {
                newArray.push(oldJournal[i])
            }
        }
        return newArray
      })
  }

  function updateJournalTitle(title) {
    setjournal(oldjournal => oldjournal.map(oldJournal => {
        return oldJournal.id === currentJournalId
            ? { ...oldJournal, title: title }
            : oldJournal
    }))
}

  function toggle() {
    toggleHome(prevState => !prevState)
  }
  
  function findCurrentJournal() {
      return journal.find(Journal => {
          return Journal.id === currentJournalId
      }) || journal[0]
  }

  useEffect(() => {
    var bcolor = document.body

    if (darkMode) {
      bcolor.style.backgroundColor = '#212121'
      localStorage.setItem('dark', true)
    } else {
      bcolor.style.backgroundColor = '#f4f4f4'
      localStorage.removeItem('dark')
    }
  })
  
  return (
      <main className={`w-screen h-screen relative overflow-x-hidden ${darkMode ? "dark" : ""}`}>
        {
            home === false
            ?
            <Editor
              mode={darkMode}
              journals={journal}
              currentJournal={findCurrentJournal()}
              updateJournalBody={updateJournalBody} 
              updateJournalTitle={updateJournalTitle} 
              toggle={toggle}
              />
            :
            <Home
            toggleMode={toggleDark}
            mode={darkMode}
            journals={journal}
            deleteJournal={deleteJournal}
            currentJournal={findCurrentJournal()}
            setCurrentJournalId={setCurrentJournalId}
            newJournal={createNewJournal}
            toggle={toggle} />
            
        }
        <Footer 
        mode={darkMode} />
      </main>
  )
}
